import { handleActions } from 'redux-actions';
import { Map } from 'immutable';
import * as actions from '../actions/pureActions/certificateActions';
import { createAsyncReducer, initialAsyncState } from '../utils/asyncHelpers';
import {
  EXPORT_CERTIFICATES,
  GET_COUNTRIES_AND_REGISTRIES,
  TRANSFER_CERTIFICATES,
} from '../constants/actionTypes/transferringCertificatesActionTypes';

const initialState = Map({
  selectedReceiver: null,
  transferring: initialAsyncState,
  exporting: initialAsyncState,
  countriesAndRegistries: initialAsyncState,
});

export default handleActions(
  {
    ...createAsyncReducer(TRANSFER_CERTIFICATES, 'transferring'),
    ...createAsyncReducer(EXPORT_CERTIFICATES, 'exporting'),
    ...createAsyncReducer(
      GET_COUNTRIES_AND_REGISTRIES,
      'countriesAndRegistries'
    ),
    [actions.selectReceiver]: (state, { payload }) =>
      state.merge({ selectedReceiver: payload }),
    [actions.selectCountryOrRegistry]: (state, { payload }) =>
      state.merge({ selectedCountryOrRegistry: payload }),
  },
  initialState
);

export const getSelectedReceiver = (state) =>
  state.getIn(['transferringCertificate', 'selectedReceiver']);

export const getSelectedCountryOrRegistry = (state) =>
  state.getIn(['transferringCertificate', 'selectedCountryOrRegistry']);

export const getCountriesAndRegistries = (state) =>
  state.getIn(['transferringCertificate', 'countriesAndRegistries']).toJS()
    .data;

export const getTransferring = (state) =>
  state.getIn(['transferringCertificate', 'transferring']);

export const getExporting = (state) =>
  state.getIn(['transferringCertificate', 'exporting']);
